import React from 'react'

import { SOCIAL_LINKS } from '../siteConfig'

function Footer() {
    return (
        <footer className="footer-area" style={{backgroundImage: `url(${process.env.PUBLIC_URL}/images/footer/footer-bg.png)`}}>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-12 col-md-6">
                        <div className="single-footer-widget">
                            <div className="footer-social-links footer-menu">
                                <span>Stay Connected:</span>
                                <ul>
                                    {SOCIAL_LINKS.map((link) => (
                                        <li key={link.key}>
                                            <a href={link.href} target="_blank" rel="noopener noreferrer" aria-label={link.label}>
                                                <i className={`fa ${link.icon}`} aria-hidden="true"></i>
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="single-footer-widget">
                            <div className="footer-bottom">
                                <div className="copyright-text">
                                    <p>Copyrights © {(new Date()).getFullYear()} <a className="thm-clr" href="/">Nutrism</a> All Right Reserved.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
